import useWindowSize from "./useWindowSize";

export default () => {
  const windowSize = useWindowSize();

  const breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  };

  const isMobile = windowSize.width < breakpoints.sm;
  const isTablet =
    windowSize.width < breakpoints.md && windowSize.width >= breakpoints.sm;
  const isDesktop = windowSize.width >= breakpoints.lg;

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
